import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { AuditNotificationsState } from './audit-notifications.state';

// Thin NgModule wrapper so the state can be imported directly into standalone
// component imports[] — identical pattern to NotificationsStateModule.
@NgModule({ imports: [NgxsModule.forFeature([AuditNotificationsState])] })
export class AuditNotificationsStateModule {}
